import {TranslatorDashboardHeader} from './header.js';
import {GoCheckHistory} from './gocheck_history.js';
import {Metrics} from './metrics.js';
import {Realtime} from './realtime.js';

class TranslatorDashboard {
  constructor($) {
    console.info('Initializing TranslatorDashboard');
    this.$ = $;
    this.$el = this.$('.td-container');
    if(this.$el.length === 0) {
      return;
    }

    self.header = new TranslatorDashboardHeader($);
    self.metrics = new Metrics($);
    self.gocheck = new GoCheckHistory($);
    self.realtime = new Realtime($);

    this.initPopover();
    this.initClickableTableRow();
    this.initTweetForNewWorker();
    this.initTrackRssLink();
  }

  initPopover() {
    this.callPopover('.td-list-popover-level', '#td-popover-template-level', 'right');
    this.callPopover('.td-list-popover-info', '#td-popover-template-info', 'left');
    this.callPopover('.td-list-popover-available', '#td-popover-template-available', 'bottom');
    this.callPopover('.td-list-popover-bonus', '#td-popover-template-bonus', 'left');
    this.callPopover('.td-list-popover-priority', '#td-popover-template-priority', 'right');
    this.callPopover('.td-popover-template-rtd', '#td-popover-template-rtd', 'right');
    this.callPopover(
      '.td-list-popover-gocheck-history',
      '#td-popover-template-gocheck-history',
      'gocheck-history-popover-box right'
    );
    this.$('body').on('click', (e)=> {
      if(this.$(e.target).closest('.popover, .td-list-popover').length === 0) {
        this.$el.find('.td-list-popover').popover('hide');
      }
    });
  }

  callPopover(className, contentID, placement) {
    let html = this.$el.find(contentID).html();

    if(html) {
      this.$el.find(className).popover({
        html: true,
        content: this.$(html.trim()),
        container: 'body',
        placement: placement
      });
    }
  }

  initClickableTableRow() {
    this.$el.find('.td-list').on('click', '.td-list-row', (e)=> {
      if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) {
        // ignore when you press "Command(Mac) or Ctrl(windows)" key
        return;
      }
      document.location.href = this.$(e.target).closest('.td-list-row').data('detail-url');
    });
  }

  initTweetForNewWorker() {
    this.$el.find('.td-new-worker-twitter-container').on('click', '.td-worker-twitter-link', (e)=> {
      e.preventDefault();
      var status_msg = $('#td-worker-twitter-tweet').val();
      status_msg = encodeURIComponent(status_msg);
      var url = 'http://twitter.com/home?status='+status_msg;
      window.location.href=url;
    });
  }

  initTrackRssLink() {
    this.$el.find('.td-job-rss-link').on('click', (e)=> {
      if (window['dataLayer']) {
        dataLayer.push({event:'event', category:'tc', action:'click', label:'ClickJobRSSFeedLink'});
      }
    });
  }
}

$(document).ready(function() {
    let dashboard = new TranslatorDashboard($);
});



// WEBPACK FOOTER //
// ./style-guide-extends/js/translator-dashboard/index.js